import type { CarerContract } from '@shared/modules/carer-contracts/carer-contract';
import { CarerPresenter } from '@shared/modules/carers/carer.presenter';

import { Presenter } from '@shared/presenters/presenter';
import { readableDateRange } from '@shared/utils/dates/readable-date-range';
import { DateTime } from 'luxon';

export class CarerContractPresenter extends Presenter<CarerContract> {
    get carer(): CarerPresenter {
        return this.present('carer.data', CarerPresenter);
    }

    get name() {
        return this.get('name');
    }

    get description() {
        return this.name;
    }

    get startDateTime() {
        return this.toDateTime('start', false);
    }

    get startDate() {
        return this._get('startDate', () => this.formatDateShort(this.startDateTime));
    }

    get finishDateTime() {
        return this.toDateTime('finish', false);
    }

    get finishDate() {
        return this._get('finishDate', () => this.formatDateShort(this.finishDateTime));
    }

    get dateRange() {
        return this._get('dateRange', () => {
            const start = this.startDateTime;
            const finish = this.finishDateTime;

            if (!start) {
                return;
            }

            if (!finish) {
                return `${this.formatDateShort(start)} &rarr; continuing`;
            }

            return readableDateRange(start, finish);
        });
    }

    isActive(date: DateTime | true = DateTime.local()) {
        if (date === true) {
            date = DateTime.local();
        }

        date = date.toLocal().startOf('day');

        return this._get(`isActive:${date.toSQLDate()}`, () => {
            const start = this.startDateTime;
            const finish = this.finishDateTime;

            if (!start && !finish) {
                return false;
            }

            if (start > date) {
                return false;
            }

            return !(finish && finish <= date);
        });
    }
}
